import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EditChildPhotoComponent} from "../modals/edit-child-photo/edit-child-photo.component";
import {ModalController} from "@ionic/angular";
import {Child} from "../../../types/interfaces";
import {ParentService} from "../../../services/mygreencountry/parent.service";

@Component({
    selector: 'app-child-card',
    templateUrl: './child-card.component.html',
    styleUrls: ['./child-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChildCardComponent implements OnInit {

    @Input() child?: Child;

    @Input() isActive: boolean = false;
    @Input() canEnter: boolean = false;
    @Input() canEnterStyle2: boolean = false;
    @Input() showActive: boolean = false;

    @Output() enterStudentCabinet = new EventEmitter();
    @Output() reloadDashboard = new EventEmitter();

    constructor(private modalCtrl: ModalController, private parentService: ParentService) {
    }

    ngOnInit() {
    }

    async openEditPhotoModal() {

        const modal = await this.modalCtrl.create({
            component: EditChildPhotoComponent,
            cssClass: 'edit-child-photo-modal',
            componentProps: {
                childId: this.child ? this.child.id : null,
                selectedImageBase: this.child ? this.child.avatar : null
            }
        });

        modal.onWillDismiss().then(({data, role}) => {
            if (role === 'reload') {
                this.reloadDashboard.emit(true);
            }
        });

        await modal.present();
    }

    enterAsStudent() {
        this.enterStudentCabinet.emit(true);
    }

}
